import { questTheme } from '@/app/core/theme';
import { theme } from '@ssar-app/uikit/src/theme';

export const mainTheme = {
  ...theme,
  components: {
    ...theme.components,
    Button: {
      ...theme.components.Button,
      ...questTheme.components.Button,
    },
    RadioGroup: {
      ...theme.components.RadioGroup,
      ...questTheme.components.RadioGroup,
    },
  },
};
